<template>
  <div>
    <a-space direction="vertical" size="large" style="width: 100%;">
      <a-card title="Charger Information" class="custom-card">
        <a-space direction="vertical" size="large" style="width: 100%;">
          <a-form :form="chargerSearchForm" @submit="handleChargerSearch" class="custom-card-form">
            <a-row :gutter="24">
              <a-col :span="8">
                <a-form-item label="Company">
                  <a-select
                    @change="onCompanyChange"
                    v-decorator="[
                      'company',
                      {
                        rules: [
                          {
                            required: true,
                            message: 'Please select a company!'
                          }
                        ]
                      }
                    ]"
                    :allowClear="true"
                    placeholder="Select company"
                  >
                    <a-select-option v-for="(item, index) in displayCompanies" :key="index" :value="item">
                      {{ item }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item label="Location">
                  <a-select
                    v-decorator="[
                      'depot',
                      {
                        rules: [
                          {
                            required: true,
                            message: 'Please select a location!'
                          }
                        ]
                      }
                    ]"
                    :allowClear="true"
                    placeholder="Select location"
                    :disabled="depotDisabled"
                  >
                    <a-select-option v-for="(item, index) in depotList" :key="index" :value="item">
                      {{ item }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="8" :style="{ textAlign: 'right' }">
                <a-form-item>
                  <a-button type="primary" html-type="submit" icon="search">
                    Search Chargers
                  </a-button>
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
          <div>
            <a-table
              :columns="chargerColumns"
              :dataSource="handleChargerData"
              :scroll="{ x: 1500, y: 1000 }"
              :loading="chargerDataLoading"
              :rowKey="record => record.macID"
              :pagination="{
                defaultPageSize: 10,
                showSizeChanger: true
              }"
              bordered
              :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            >
              <span slot="footer">
                {{ this.chargerData.length + " Total Chargers Found" }}
              </span>
            </a-table>
          </div>
        </a-space>
      </a-card>
      <a-card title="Program File Upload" class="custom-card">
        <template slot="extra">
          <a-space size="middle">
            <a-button type="primary" icon="upload" @click="() => (this.uploadFileModalVisible = true)"
              >Upload File</a-button
            >
            <a-button @click="loadFiles" type="primary" icon="reload">Reload</a-button>
            <a-button
              type="primary"
              :disabled="selectedFileRowKeys == 0 || selectedRowKeys == 0"
              icon="cloud-download"
              @click="handleDeployToChargers"
              v-if="!deploymentInProgress"
              >Deploy to Chargers</a-button
            >
            <a-button type="primary" @click="() => (updateProgressModalVisible = true)" v-else
              >View Deployment Progress</a-button
            >
          </a-space>
        </template>
        <div>
          <a-table
            :columns="fileColumns"
            :dataSource="handleFileData"
            :scroll="{ x: 1500, y: 1000 }"
            :loading="fileDataLoading"
            :rowKey="record => record.Key"
            :pagination="{
              defaultPageSize: 5,
              showSizeChanger: true,
              pageSizeOptions: ['5', '10', '15']
            }"
            bordered
            :row-selection="{ selectedRowKeys: selectedFileRowKeys, onChange: onFileSelectChange, type: 'radio' }"
          >
            <span slot="actions" slot-scope="fileObject">
              <a @click="downloadFile(fileObject)">Download</a>
              <a-divider type="vertical" />
              <a @click="displayMoreInformation(fileObject)">More Information</a>
            </span>
          </a-table>
        </div>
      </a-card>
    </a-space>
    <a-modal
      v-model="uploadFileModalVisible"
      title="Upload Program File"
      centered
      :afterClose="
        () => {
          this.uploadFileForm.resetFields();
          this.uploadFileList = [];
          this.uploadFileButtonDisabled = false;
        }
      "
    >
      <a-form layout="vertical" id="uploadFileForm" :form="uploadFileForm" @submit="uploadFile">
        <a-row :gutter="24">
          <a-col :span="24">
            <a-form-item label="Program File:" style="text-align: center">
              <div class="dropbox">
                <a-upload
                  v-decorator="[
                    'programFile',
                    {
                      valuePropName: 'fileList',
                      getValueFromEvent: normalizeFile,
                      rules: [
                        {
                          required: true,
                          message: 'Please select a file!'
                        }
                      ]
                    }
                  ]"
                  accept=".zip"
                  :headers="headers"
                  :customRequest="dummyUploadRequest"
                  :multiple="false"
                >
                  <a-button icon="upload" :disabled="uploadFileButtonDisabled">Select Zip File</a-button>
                </a-upload>
              </div>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="24">
            <a-form-item label="Hardware Type:">
              <a-select
                v-decorator="[
                  'hardwareType',
                  {
                    rules: [
                      {
                        required: true,
                        message: 'Please select a hardware type!'
                      }
                    ]
                  }
                ]"
                :allowClear="true"
                placeholder="Select hardware type"
              >
                <a-select-option key="1" value="ccimx6sbc">
                  ccimx6sbc
                </a-select-option>
                <a-select-option key="2" value="ccimx6ulstarter">
                  ccimx6ulstarter
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="24">
            <a-form-item label="Notes:">
              <a-textarea
                allowClear
                placeholder="Additional notes"
                :auto-size="{ minRows: 3, maxRows: 5 }"
                v-decorator="['notes']"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <template slot="footer">
        <a-button form="uploadFileForm" type="primary" html-type="submit" :loading="uploadFileButtonLoading">
          Upload File
        </a-button>
      </template>
    </a-modal>
    <a-modal
      v-model="fileInformationModalVisible"
      title="Program File Information"
      :footer="null"
      :afterClose="
        () => {
          this.fileObjectInformation = {};
        }
      "
    >
      <p><b>File Name: </b>{{ this.fileObjectInformation.key }}</p>
      <p><b>Uploaded By: </b>{{ this.fileObjectInformation.uploadedBy }}</p>
      <p><b>Hardware Type: </b>{{ this.fileObjectInformation.hardwareType }}</p>
      <p><b>Notes: </b>{{ this.fileObjectInformation.notes }}</p>
    </a-modal>
    <a-modal v-model="updateProgressModalVisible" title="Deployment Progress Information" :width="700">
      <template slot="footer">
        <a-tooltip>
          <template slot="title">
            Timeout of {{ getDeploymentTimeout(selectedRows.length) / 60000 }} minutes set.
          </template>
          <a-button key="done" type="primary" :disabled="deploymentInProgress" @click="handleUpdateDone">
            Done
          </a-button>
        </a-tooltip>
      </template>
      <a-table
        :columns="updateProgressColumns"
        :dataSource="updateProgressData"
        :pagination="false"
        :rowKey="record => record.macID"
      >
      </a-table>
    </a-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { cloneDeep } from "lodash";

export default {
  data() {
    return {
      chargerSearchForm: this.$form.createForm(this),
      uploadFileForm: this.$form.createForm(this),
      chargerData: [],
      fileData: [],
      depotList: [],
      selectedRowKeys: [],
      selectedRows: [],
      selectedFileRowKeys: [],
      selectedFileRows: [],
      uploadFileList: [],
      updateProgressData: [],
      fileObjectInformation: {},
      chargerDataLoading: false,
      fileDataLoading: false,
      uploadFileModalVisible: false,
      uploadFileButtonLoading: false,
      uploadFileButtonDisabled: false,
      fileInformationModalVisible: false,
      updateProgressModalVisible: false,
      deploymentInProgress: false,
      depotDisabled: true,
      headers: {
        authorization: "authorization-text"
      },
      fileColumns: [
        {
          dataIndex: "Key",
          title: "File Name",
          align: "center",
          sorter: (recordOne, recordTwo) => recordOne.Key.localeCompare(recordTwo.Key)
        },
        {
          dataIndex: "uploadTime",
          title: "Upload Time",
          align: "center",
          sorter: (objectOne, objectTwo) => {
            let dateOne = new Date(objectOne.LastModified.toISOString());
            let dateTwo = new Date(objectTwo.LastModified.toISOString());
            return dateTwo - dateOne;
          }
        },
        {
          dataIndex: "Size",
          title: "File Size",
          customRender: size => {
            if (size / 1000000 > 1) {
              return (size / 1000000).toFixed(1) + " MB";
            } else if (size / 1000 > 1) {
              return (size / 1000).toFixed(1) + " KB";
            } else {
              return size.toFixed(1) + " B";
            }
          },
          align: "center",
          sorter: (recordOne, recordTwo) => recordOne.Size - recordTwo.Size
        },
        {
          title: "Actions",
          align: "center",
          scopedSlots: { customRender: "actions" }
        }
      ],
      updateProgressColumns: [
        {
          dataIndex: "chargerNumber",
          title: "Charger Number",
          align: "center",
          sorter: (recordOne, recordTwo) => recordOne.chargerNumber - recordTwo.chargerNumber
        },
        {
          dataIndex: "macID",
          title: "MAC Address",
          align: "center",
          sorter: (recordOne, recordTwo) => recordOne.macID.localeCompare(recordTwo.macID)
        },
        {
          title: "Progress",
          dataIndex: "progressPercentage",
          align: "center",
          customRender: (percentage, rowData) => {
            if (rowData.status == "inProgress") {
              return <a-progress percent={percentage} status="active" size="small" />;
            } else if (rowData.status == "error") {
              return <a-progress percent={percentage} status="exception" size="small" />;
            } else {
              return <a-progress percent={percentage} size="small" />;
            }
          },
          width: 200
        },
        {
          dataIndex: "description",
          title: "Message",
          align: "center",
          width: 200
        }
      ]
    };
  },

  props: ["AWS", "masterCompanyMap"],

  computed: {
    ...mapState(["UserName", "PoolData", "AccessGroups"]),

    // function to display the list of companies user is authenticated for.
    displayCompanies() {
      let companyList = [];
      this.masterCompanyMap.forEach(function(value, key) {
        companyList.push(key);
      });
      return companyList.sort();
    },

    handleChargerData() {
      // copy data over, assign key to each record, and sort/filter it according to requirements.
      const data = this.chargerData;
      data.sort((recordOne, recordTwo) => {
        return recordOne.depot.localeCompare(recordTwo.depot) == 0
          ? recordOne.chargerNumber - recordTwo.chargerNumber
          : recordOne.depot.localeCompare(recordTwo.depot);
      });
      return data;
    },

    handleFileData() {
      // copy data over and sort/filter it according to requirements.
      const data = this.fileData;
      data
        .sort((objectOne, objectTwo) => {
          let dateOne = new Date(objectOne.LastModified.toISOString());
          let dateTwo = new Date(objectTwo.LastModified.toISOString());
          return dateTwo - dateOne;
        })
        .forEach(fileObject => {
          fileObject.uploadTime = fileObject.LastModified.toLocaleString();
        });
      return data;
    },

    hasSelectedMultiple() {
      let otherDepots = this.selectedRows.filter(depot => {
        return depot.company !== this.selectedRows[0].company;
      });
      return this.selectedRowKeys.length >= 2 && !otherDepots.length;
    },

    chargerColumns() {
      let chargerColumns = [
        {
          dataIndex: "depot",
          title: "Depot Name",
          align: "center",
          width: 220
        },
        {
          dataIndex: "chargerNumber",
          title: "Charger Number",
          align: "center",
          sorter: (recordOne, recordTwo) => recordOne.chargerNumber - recordTwo.chargerNumber
        },
        {
          dataIndex: "macID",
          title: "MAC Address",
          align: "center",
          sorter: (recordOne, recordTwo) => recordOne.macID.localeCompare(recordTwo.macID)
        },
        {
          title: "Hardware Type",
          dataIndex: "hardwareType",
          align: "center",
          customRender: hardwareType => {
            if (!hardwareType) {
              return "N/A";
            }
            return hardwareType;
          },
          filters: [
            {
              text: "ccimx6sbc",
              value: "ccimx6sbc"
            },
            {
              text: "ccimx6ulstarter",
              value: "ccimx6ulstarter"
            }
          ],
          filterMultiple: false,
          onFilter: (value, record) => record.hardwareType === value
        },
        {
          title: () => {
            return (
              <span>
                Program Version&nbsp;
                <a-tooltip title="Program Version may not be available from the gateway if it is offline or fails to respond within the timeout period.">
                  <a-icon type="info-circle" />
                </a-tooltip>
              </span>
            );
          },
          dataIndex: "programVersion",
          customRender: (programVersion, row) => {
            if (!row.reportedProgramVersion) {
              return (
                <a-badge status="error">
                  <a-popover title="Program Version Information" placement="top">
                    <template slot="content">
                      <p>
                        <b>Program Version in Database: </b>
                        {programVersion ? programVersion : "N/A"}
                      </p>
                    </template>
                    Not Available
                  </a-popover>
                </a-badge>
              );
            } else if (programVersion != row.reportedProgramVersion) {
              return (
                <a-badge status="warning">
                  <a-popover title="Program Version Information" placement="top">
                    <template slot="content">
                      <p>
                        <b>Program Version in Database: </b>
                        {programVersion ? programVersion : "N/A"}
                      </p>
                    </template>
                    {row.reportedProgramVersion}
                  </a-popover>
                </a-badge>
              );
            } else {
              return (
                <a-badge status="success">
                  <a-popover title="Program Version Information" placement="top">
                    <template slot="content">
                      <p>
                        <b>Program Version in Database: </b>
                        {programVersion ? programVersion : "N/A"}
                      </p>
                    </template>
                    {row.reportedProgramVersion}
                  </a-popover>
                </a-badge>
              );
            }
          },
          align: "center"
        },
        {
          title: "Updated By",
          dataIndex: "updatedBy",
          align: "center"
        },
        {
          title: "Last Updated",
          dataIndex: "revision",
          customRender: revision => {
            if (revision) {
              return this.$moment(revision)
                .local()
                .format("YYYY-MM-DD HH:mm");
            } else {
              return "N/A";
            }
          },
          align: "center"
        }
      ];
      return chargerColumns;
    }
  },

  methods: {
    handleChargerSearch(e) {
      e.preventDefault();
      this.chargerSearchForm.validateFields((error, fieldValues) => {
        if (error) {
          return;
        }
        this.loadChargerData(fieldValues.company, fieldValues.depot);
      });
    },

    async loadChargerData(selectedCompany, selectedDepot) {
      try {
        this.chargerDataLoading = true;
        this.chargerData = [];
        this.selectedRowKeys = [];
        this.selectedRows = [];
        var promiseArray = [];
        if (selectedDepot) {
          // first, query the DPO# object from the database in order to get the latest chargerList.
          let depotParams = {
            entityId: "DPO#" + selectedDepot,
            objectType: "DPO",
            operation: "get",
            region: this.masterCompanyMap.get(selectedCompany).region
          };
          let depotDataArray = await this.sendRequest(depotParams, {}, "get");
          if (!depotDataArray.length) {
            throw new Error("No DPO# object found for the selected location!");
          }
          let chargerList = JSON.parse(depotDataArray[0].chargerList);
          chargerList.forEach(charger => {
            let chargerParams = {
              entityId: charger.entityId,
              objectType: "CHG",
              operation: "get",
              region: this.masterCompanyMap.get(selectedCompany).region
            };
            promiseArray.push(this.sendRequest(chargerParams, {}, "get"));
          });
        } else {
          let listOfLocations = this.masterCompanyMap.get(selectedCompany).depots;
          // only proceed if the company has a non-empty list of depots.
          if (listOfLocations) {
            let depotPromiseArray = [];
            listOfLocations.forEach(depot => {
              let params = {
                entityId: "DPO#" + depot,
                objectType: "DPO",
                operation: "get",
                region: this.masterCompanyMap.get(selectedCompany).region
              };
              depotPromiseArray.push(this.sendRequest(params, {}, "get"));
            });
            let depotDataArray = await Promise.all(depotPromiseArray);
            let depotData = depotDataArray.flat(Infinity);
            // check if no data is returned; display a message to user in that case.
            if (!depotData.length) {
              throw new Error("No DPO# object(s) found for the selected company!");
            }
            // iterate through each depot's chargerList and create promises to query the charger objects.
            depotData.forEach(depotObject => {
              let chargerList = JSON.parse(depotObject.chargerList);
              chargerList.forEach(charger => {
                let chargerParams = {
                  entityId: charger.entityId,
                  objectType: "CHG",
                  operation: "get",
                  region: this.masterCompanyMap.get(selectedCompany).region
                };
                promiseArray.push(this.sendRequest(chargerParams, {}, "get"));
              });
            });
          }
        }
        let chargerDataArray = await Promise.all(promiseArray);
        let data = chargerDataArray.flat(Infinity);
        // check if no data is returned; display a message to user in that case.
        if (!data.length) {
          throw new Error("No data available for selected fields!");
        }
        await this.getProgramVersions(selectedCompany, selectedDepot, data);
        this.chargerData = data;
        this.chargerDataLoading = false;
      } catch (error) {
        this.$message.error("Error loading charger data: " + (error.message ? error.message : error));
        this.chargerDataLoading = false;
      }
    },

    sendRequest(params, body, requestType) {
      // before making an API request, check to make sure user has access to perform the action / credentials need to be refreshed.
      return new Promise((resolve, reject) => {
        this.AWS.config.credentials.get(async credentialError => {
          if (credentialError) {
            if (credentialError.name === "NotAuthorizedException") {
              reject(
                new Error(
                  "You are not authorized to perform this action. Please contact Support Team if you think this is a mistake."
                )
              );
            } else {
              reject(credentialError.message);
            }
          } else {
            try {
              var aws4 = require("aws4");
              let paramsUrl = this.createParamsUrl(params);
              switch (requestType) {
                case "get": {
                  let request = {
                    host: "v9ovun9ana.execute-api.us-west-2.amazonaws.com",
                    method: "GET",
                    url: "https://v9ovun9ana.execute-api.us-west-2.amazonaws.com/prod/configure?" + paramsUrl,
                    path: "/prod/configure?" + paramsUrl,
                    service: "execute-api"
                  };
                  let signedRequest = aws4.sign(request, {
                    secretAccessKey: this.AWS.config.credentials.secretAccessKey,
                    accessKeyId: this.AWS.config.credentials.accessKeyId,
                    sessionToken: this.AWS.config.credentials.sessionToken
                  });
                  // delete unsafe headers from the signed request.
                  delete signedRequest.headers["Host"];
                  delete signedRequest.headers["Content-Length"];

                  let response = await this.$axios(signedRequest);
                  let items = response.data.Items;
                  resolve(items);
                  break;
                }
                case "post": {
                  let request = {
                    host: "v9ovun9ana.execute-api.us-west-2.amazonaws.com",
                    method: "POST",
                    url: "https://v9ovun9ana.execute-api.us-west-2.amazonaws.com/prod/configure?" + paramsUrl,
                    path: "/prod/configure?" + paramsUrl,
                    service: "execute-api",
                    data: body,
                    body: JSON.stringify(body),
                    headers: {
                      "content-type": "application/json"
                    }
                  };
                  let signedRequest = aws4.sign(request, {
                    secretAccessKey: this.AWS.config.credentials.secretAccessKey,
                    accessKeyId: this.AWS.config.credentials.accessKeyId,
                    sessionToken: this.AWS.config.credentials.sessionToken
                  });
                  // delete unsafe headers from the signed request.
                  delete signedRequest.headers["Host"];
                  delete signedRequest.headers["Content-Length"];

                  let response = await this.$axios(signedRequest);
                  let responseData = response.data;
                  resolve(responseData);
                  break;
                }
                default:
                  break;
              }
            } catch (error) {
              // if no response is available, means it is a network error.
              if (!error.response) {
                reject(new Error("Network Error. Please try again!"));
              } else {
                let response = error.response;
                if (response.status == 403) {
                  reject(
                    "You are not authorized to perform this action. Please contact Support Team if you think this is a mistake."
                  );
                } else {
                  reject(response.data.message);
                }
              }
            }
          }
        });
      });
    },

    getProgramVersions(selectedCompany, selectedDepot, chargerData) {
      return new Promise(resolve => {
        var AWSIoTData = require("aws-iot-device-sdk");
        this.AWS.config.credentials.get(identityError => {
          if (!identityError) {
            try {
              var depots = selectedDepot ? [selectedDepot] : this.masterCompanyMap.get(selectedCompany).depots;
              var messageCounter = 0;
              var region = this.masterCompanyMap.get(selectedCompany).region;
              const mqttClient = AWSIoTData.device({
                region: region,
                host: "a3ijg5gjke8m6j-ats.iot." + region + ".amazonaws.com",
                clientId: "elmsWebsiteClient_" + this.UserName,
                protocol: "wss",
                debug: false,
                reconnectPeriod: 0,
                accessKeyId: this.AWS.config.credentials.accessKeyId,
                secretKey: this.AWS.config.credentials.secretAccessKey,
                sessionToken: this.AWS.config.credentials.sessionToken
              });
              mqttClient.on("close", () => {
                // end the client connection again in case connection was automatically closed.
                mqttClient.end();
              });
              mqttClient.on("connect", () => {
                // on connection, firstly subscribe to the chargerStatus topics.
                mqttClient.subscribe("ioc/+/+/chargerStatus", {
                  qos: 1
                });
                depots.forEach(depot => {
                  // next, publish messages to request the program version for all the chargers under each depot.
                  let messagePayload = {
                    payload: "01",
                    timestamp: new Date()
                  };
                  if (selectedCompany != "amplyPower") {
                    mqttClient.publish(
                      "ioc/" + depot + "/FFFFFFFFFFFF/cmd/getChargerStatus",
                      JSON.stringify(messagePayload),
                      { qos: 1 }
                    );
                  } else {
                    mqttClient.publish(
                      "ioc/" + selectedCompany + "/FFFFFFFFFFFF/cmd/getChargerStatus",
                      JSON.stringify(messagePayload),
                      { qos: 1 }
                    );
                  }
                });
                setTimeout(() => {
                  // once timeout is reached, end the client connections.
                  mqttClient.end();
                  resolve();
                }, this.getConnectionTimeout(chargerData.length));
              });
              mqttClient.on("error", () => {
                throw new Error("Error thrown by MQTT Client.");
              });
              mqttClient.on("message", (topic, payload) => {
                var macID = topic.split("/")[2];

                let chargerObject = chargerData.find(charger => charger.macID === macID);
                if (chargerObject) {
                  chargerObject.reportedProgramVersion = JSON.parse(payload).programVersion;
                  chargerObject.hardwareType = JSON.parse(payload).hardwareType;
                  messageCounter += 1;
                  // this means we have received a response from all the chargers and can close the connection.
                  if (messageCounter == chargerData.length) {
                    mqttClient.end();
                    resolve();
                  }
                }
              });
            } catch (error) {
              resolve();
            }
          } else {
            resolve();
          }
        });
      });
    },

    loadFiles() {
      this.AWS.config.credentials.get(identityError => {
        if (!identityError) {
          try {
            this.fileDataLoading = true;
            var s3object = new this.AWS.S3({ apiVersion: "2006-03-01" });
            let listFilesParams = {
              Bucket: "g4cccm01"
            };
            s3object.listObjects(listFilesParams, (error, data) => {
              if (error) {
                this.$message.error("Error listing program files from S3: " + (error.message ? error.message : error));
                this.fileDataLoading = false;
              } else {
                this.fileData = data.Contents.filter(object => {
                  return object.Key.includes(".zip");
                });
                this.fileDataLoading = false;
              }
            });
          } catch (error) {
            this.$message.error("Error listing program files from S3: " + (error.message ? error.message : error));
            this.fileDataLoading = false;
          }
        } else {
          if (identityError.name === "NotAuthorizedException") {
            this.$message.error(
              "You are not authorized to perform this action. Please contact Support Team if you think this is a mistake."
            );
          } else {
            this.$message.error("Error listing program files from S3: " + identityError.message);
          }
        }
      });
    },

    uploadFile(formEvent) {
      formEvent.preventDefault();
      this.uploadFileForm.validateFields((error, fieldValues) => {
        if (error) {
          return;
        }
        let selectedFile = fieldValues.programFile[0];
        if (selectedFile.status != "done") {
          this.$message.error("Selected file not attached successfully. Please try again!");
          return;
        }
        this.AWS.config.credentials.get(identityError => {
          if (!identityError) {
            try {
              this.uploadFileButtonLoading = true;
              var s3object = new this.AWS.S3({ apiVersion: "2006-03-01" });
              var putParams = {
                Body: selectedFile.originFileObj,
                Bucket: "g4cccm01",
                Key: selectedFile.name,
                ContentType: "application/zip",
                Metadata: {
                  uploadedby: this.UserName,
                  notes: fieldValues.notes ? fieldValues.notes : "N/A",
                  hardwaretype: fieldValues.hardwareType
                }
              };
              s3object.putObject(putParams, putError => {
                if (putError) {
                  this.$message.error(
                    "Error uploading program file to S3: " + (putError.message ? putError.message : putError)
                  );
                  this.uploadFileButtonLoading = false;
                  this.uploadFileModalVisible = false;
                } else {
                  this.$message.success(`${selectedFile.name} uploaded to S3 successfully.`);
                  this.uploadFileButtonLoading = false;
                  this.uploadFileModalVisible = false;
                  this.loadFiles();
                }
              });
            } catch (error) {
              this.$message.error("Error uploading program file to S3: " + (error.message ? error.message : error));
              this.uploadFileButtonLoading = false;
              this.uploadFileModalVisible = false;
            }
          } else {
            if (identityError.name === "NotAuthorizedException") {
              this.$message.error(
                "You are not authorized to perform this action. Please contact Support Team if you think this is a mistake."
              );
            } else {
              this.$message.error("Error uploading program file to S3: " + identityError.message);
            }
          }
        });
      });
    },

    handleDeployToChargers() {
      this.AWS.config.credentials.get(identityError => {
        if (!identityError) {
          try {
            this.deploymentInProgress = true;
            var counter = 0;
            var s3object = new this.AWS.S3({ apiVersion: "2006-03-01" });
            let selectedFile = this.selectedFileRows[0];
            let startIndex = selectedFile.Key.indexOf("V");
            let endIndex = selectedFile.Key.indexOf("_", startIndex);
            let newVersion = selectedFile.Key.substring(startIndex, endIndex);
            // create a promise to get a signed URL for the selected file.
            var urlParams = { Bucket: "g4cccm01", Key: selectedFile.Key, Expires: 60 };
            var urlPromise = s3object.getSignedUrlPromise("getObject", urlParams);
            urlPromise.then(
              url => {
                var AWSIoTData = require("aws-iot-device-sdk");
                var selectedCompany = this.chargerSearchForm.getFieldValue("company");
                var region = this.masterCompanyMap.get(selectedCompany).region;
                var depot = this.chargerSearchForm.getFieldValue("depot");
                const mqttClient = AWSIoTData.device({
                  region: region,
                  host: "a3ijg5gjke8m6j-ats.iot." + region + ".amazonaws.com",
                  clientId: "elmsWebsiteClient_" + this.UserName,
                  protocol: "wss",
                  debug: false,
                  reconnectPeriod: 0,
                  accessKeyId: this.AWS.config.credentials.accessKeyId,
                  secretKey: this.AWS.config.credentials.secretAccessKey,
                  sessionToken: this.AWS.config.credentials.sessionToken
                });
                var deploymentTimeout = setTimeout(() => {
                  // once timeout is reached, end the client connections.
                  if (this.updateProgressData.length) {
                    this.$warning({
                      title: "Deployment Taking Longer Than Usual",
                      content:
                        "The deployment process is taking longer than usual - please check the chargers manually or refresh data. In order to prevent multiple MQTT connections, this client connection will be closed.",
                      okType: "danger",
                      onOk: () => {
                        mqttClient.end();
                      }
                    });
                  }
                }, this.getDeploymentTimeout(this.selectedRows.length));
                mqttClient.on("close", () => {
                  // end the client connection again in case connection was automatically closed.
                  this.deploymentInProgress = false;
                  clearTimeout(deploymentTimeout);
                  mqttClient.end();
                  if (!this.updateProgressModalVisible) {
                    this.updateProgressData = [];
                    this.loadChargerData(
                      this.chargerSearchForm.getFieldValue("company"),
                      this.chargerSearchForm.getFieldValue("depot")
                    );
                  }
                });
                mqttClient.on("connect", () => {
                  // on connection, firstly subscribe to the updateProgressStatus topic for all the chargers.
                  mqttClient.subscribe("ioc/+/+/status/updateProgressStatus", {
                    qos: 1
                  });
                  this.updateProgressData = [];
                  this.selectedRows.forEach(chargerObject => {
                    // next, publish messages to issue an update.
                    let messagePayload = {
                      timestamp: new Date(),
                      URL: url
                    };
                    // hardcoded for amplyPower since it does not have any depots.
                    if (selectedCompany != "amplyPower") {
                      mqttClient.publish(
                        "ioc/" + depot + "/" + chargerObject.macID + "/cmd/updateDevice",
                        JSON.stringify(messagePayload),
                        { qos: 1 }
                      );
                    } else {
                      mqttClient.publish(
                        "ioc/" + selectedCompany + "/" + chargerObject.macID + "/cmd/updateDevice",
                        JSON.stringify(messagePayload),
                        { qos: 1 }
                      );
                    }
                    this.updateProgressData.push({
                      chargerNumber: chargerObject.chargerNumber,
                      macID: chargerObject.macID,
                      status: "inProgress",
                      progressPercentage: 5,
                      description: "Update message published."
                    });
                  });
                  this.updateProgressModalVisible = true;
                });
                mqttClient.on("error", () => {
                  this.$message.error("Error encountered by MQTT Client - closing connection.");
                  mqttClient.end();
                });
                mqttClient.on("message", (topic, payload) => {
                  let macID = topic.split("/")[2];
                  let chargerObject = this.updateProgressData.find(charger => charger.macID === macID);
                  if (chargerObject) {
                    let status = JSON.parse(payload).status;
                    let description = JSON.parse(payload).description;
                    let percentage = JSON.parse(payload).percentage;

                    switch (status) {
                      case "inProgress": {
                        // only update the information if previously also in progress and the progress percentage has incremented.
                        // check to prevent misinformation when MQTT messages are delivered out of order.
                        if (chargerObject.status == "inProgress" && percentage > chargerObject.progressPercentage) {
                          chargerObject.progressPercentage = percentage;
                          chargerObject.description = description;
                          chargerObject.status = status;
                        }
                        break;
                      }
                      case "done": {
                        chargerObject.progressPercentage = percentage;
                        chargerObject.description = description;
                        chargerObject.status = status;
                        counter += 1;
                        let newChargerRecord = cloneDeep(this.selectedRows.find(charger => charger.macID === macID));
                        delete newChargerRecord.reportedProgramVersion;
                        delete newChargerRecord.hardwareType;
                        newChargerRecord.updatedBy = this.UserName;
                        newChargerRecord.programVersion = newVersion;
                        newChargerRecord.revision = new Date();
                        var updateParams = {
                          objectType: "CHG",
                          operation: "update",
                          region: region
                        };
                        var body = {
                          chargerRecord: JSON.stringify(newChargerRecord)
                        };
                        this.sendRequest(updateParams, body, "post")
                          .then(() => {
                            chargerObject.description += " and updated CHG# object.";
                          })
                          .catch(() => {
                            chargerObject.description += " but error updating CHG# object.";
                          });
                        break;
                      }
                      case "error":
                        chargerObject.description = description;
                        chargerObject.status = status;
                        counter += 1;
                        break;
                      default:
                        break;
                    }

                    if (counter == this.selectedRows.length) {
                      mqttClient.end();
                    }
                  }
                });
              },
              error => {
                this.$message.error(
                  "Error deploying program file to charger(s): " + (error.message ? error.message : error)
                );
              }
            );
          } catch (error) {
            this.$message.error(
              "Error deploying program file to charger(s): " + (error.message ? error.message : error)
            );
            this.updateProgressModalVisible = false;
          }
        } else {
          if (identityError.name === "NotAuthorizedException") {
            this.$message.error(
              "You are not authorized to perform this action. Please contact Support Team if you think this is a mistake."
            );
          } else {
            this.$message.error("Error deploying program file to charger(s): " + identityError.message);
          }
        }
      });
    },

    displayMoreInformation(fileObject) {
      try {
        var s3object = new this.AWS.S3({ apiVersion: "2006-03-01" });
        var headObjectParams = {
          Bucket: "g4cccm01",
          Key: fileObject.Key
        };
        s3object.headObject(headObjectParams, (error, data) => {
          if (error) {
            this.$message.error(
              "Error getting additional program file information: " + (error.message ? error.message : error)
            );
          } else {
            this.fileObjectInformation = {
              key: fileObject.Key,
              uploadedBy: data.Metadata["uploadedby"],
              notes: data.Metadata["notes"],
              hardwareType: data.Metadata["hardwaretype"]
            };
            this.fileInformationModalVisible = true;
          }
        });
      } catch (error) {
        this.$message.error(
          "Error getting additional program file information: " + (error.message ? error.message : error)
        );
      }
    },

    downloadFile(fileObject) {
      try {
        var s3object = new this.AWS.S3({ apiVersion: "2006-03-01" });
        var urlParams = { Bucket: "g4cccm01", Key: fileObject.Key };
        s3object.getSignedUrl("getObject", urlParams, (error, url) => {
          if (error) {
            this.$message.error("Error downloading program file: " + (error.message ? error.message : error));
          } else {
            window.open(url, "Download");
          }
        });
      } catch (error) {
        this.$message.error("Error downloading program file: " + (error.message ? error.message : error));
      }
    },

    handleUpdateDone() {
      this.updateProgressModalVisible = false;
      this.updateProgressData = [];
      this.loadChargerData(
        this.chargerSearchForm.getFieldValue("company"),
        this.chargerSearchForm.getFieldValue("depot")
      );
    },

    normalizeFile(uploadEvent) {
      if (uploadEvent.fileList.length >= 1) {
        this.uploadFileButtonDisabled = true;
      } else {
        this.uploadFileButtonDisabled = false;
      }
      if (Array.isArray(uploadEvent)) {
        return uploadEvent;
      }
      return uploadEvent && uploadEvent.fileList;
    },

    getDeploymentTimeout(numberOfChargers) {
      if (numberOfChargers == 1) {
        return 120000;
      } else if (numberOfChargers <= 5) {
        return 210000;
      } else if (numberOfChargers <= 10) {
        return 300000;
      } else if (numberOfChargers <= 15) {
        return 360000;
      } else {
        return 480000;
      }
    },

    getConnectionTimeout(dataSize) {
      if (dataSize === 1) {
        return 2500;
      } else if (dataSize <= 5) {
        return 5000;
      } else if (dataSize <= 30) {
        return 10000;
      } else {
        return 12500;
      }
    },

    onCompanyChange(value) {
      this.chargerSearchForm.resetFields(["depot"]);
      if (!value) {
        this.depotDisabled = true;
      } else {
        this.depotDisabled = false;
        this.depotList = this.masterCompanyMap.get(value).depots.sort();
        if (this.depotList.length == 1) {
          this.chargerSearchForm.setFieldsValue({ depot: this.depotList[0] });
        }
      }
    },

    createParamsUrl(paramsObject) {
      var paramsUrl = "";
      var counter = 0;
      var totalCount = Object.keys(paramsObject).length;
      for (var key in paramsObject) {
        if (paramsObject.hasOwnProperty(key)) {
          paramsUrl += key + "=" + paramsObject[key];
          if (counter != totalCount - 1) {
            paramsUrl += "&";
          }
          counter += 1;
        }
      }
      return paramsUrl.replace("#", "%23");
    },

    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },

    onFileSelectChange(selectedRowKeys, selectedRows) {
      this.selectedFileRowKeys = selectedRowKeys;
      this.selectedFileRows = selectedRows;
    },

    dummyUploadRequest({ onSuccess }) {
      setTimeout(() => {
        onSuccess("Upload Successful");
      }, 0);
    }
  },

  created() {
    // on creation, make a request to list all the program files from S3.
    this.loadFiles();
  }
};
</script>

<style>
.ant-form-item {
  margin-bottom: 5px;
}

.p {
  margin: 0;
}

.a-button {
  margin: 0 auto;
  display: block;
}

#addTimeSlot {
  z-index: 2000;
  position: relative;
}

#addUser {
  z-index: 2000;
  position: relative;
}

#backModal {
  z-index: 1000;
  position: relative;
}

.custom-card {
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  overflow-x: auto;
  min-width: 1200px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.custom-card-form .ant-form-item {
  display: flex;
}

.custom-card-form .ant-form-item-control-wrapper {
  flex: 1;
}
</style>
